import { configureStore } from '@reduxjs/toolkit'
import { createWrapper } from 'next-redux-wrapper'
import { createEpicMiddleware } from 'redux-observable'
import commonSlice, { setDelayTimer } from './reducers/common'
import liveSlice from './reducers/live'
import memberSlice from './reducers/member'
import roomSlice from './reducers/room'
import shoppingCartSlice from './reducers/shoppingCart'
import mediaSlice from './reducers/media'
import socketSlice from './reducers/socket'
import orderResultSlice from './reducers/orderResult'
import logSlice from './reducers/log'
import recentLiveStreamingSlice from './reducers/recentLiveStreaming'
import calendarSlice from './reducers/calendar'
import mallSlice from './reducers/mall'
import headerSlice from './reducers/header'
import routerSlice from './reducers/router'

import websocketEpic from './epics/websocketEpic'

const delayMiddleware =
  ({ dispatch }: any) =>
  (next: any) =>
  (action: any) => {
    const delaytime = action?.payload?.delay
    if (delaytime) {
      const timerId = setTimeout(() => {
        next(action)
      }, delaytime * 1000)

      dispatch(setDelayTimer({ timerId }))
    } else {
      next(action)
    }
  }

const makeStore = () => {
  const epicMiddleware = createEpicMiddleware()

  const store = configureStore({
    reducer: {
      common: commonSlice,
      live: liveSlice,
      member: memberSlice,
      room: roomSlice,
      shoppingCart: shoppingCartSlice,
      media: mediaSlice,
      socket: socketSlice,
      orderResult: orderResultSlice,
      log: logSlice,
      recentLiveStreaming: recentLiveStreamingSlice,
      calendar: calendarSlice,
      mall: mallSlice,
      header: headerSlice,
      router: routerSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(epicMiddleware).concat(delayMiddleware),
  })

  epicMiddleware.run(websocketEpic)

  return store
}

export const store = makeStore()

// Create wrapper
export const wrapper = createWrapper(makeStore)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
